<!-- field-dialog-templates -->

    <!-- FORM BLOCKS -->

    <div id="section-block-dlg">
        <div class="content">
            <ul class='section-block fields'>
               <li class='handle'></li>
            </ul>
        </div>
        <textarea name="data">{JSON.stringify({
            "type": "SectionBlock",
            "label": "Sección",
            "type_descr": "Sección",
            "visible": true,
            "titled": true,
            "property":"",
            "view_roles": [],
            "edit_roles": []
        })}</textarea>
        <div class="dialog">
                <label>Título</label>
                <input type="text" size="28" name="label">
                <p>Título de esta sección</p>
            <hr/>
                <label>Opciones</label>
                <p><input type="checkbox" name="visible"/>&nbsp;Visible</p>
                <p><input type="checkbox" name="titled"/>&nbsp;Con encabezado</p>
            <hr/>

            <h4>Que roles pueden ver o editar esta sección</h4>

            <label>Pueden<br>ver</label>
                <p name="view_roles" class="vars-list" data-only="fields">
                    <span class="options"></span><select></select>
                </p>
                <p>Si no se ingresa ningún rol implica que todos los roles
                    pueden ver esta sección</p>

            <label>Pueden<br>modificar</label>
                <p name="edit_roles" class="vars-list" data-only="fields">
                    <span class="options"></span><select></select>
                </p>
                <p>Si no se ingresa ningún rol implica que todos los roles
                    pueden editar esta sección.</p>
            <!-- <a class="add-field-btn" icon="add">
                <br/>Agregar un campo en esta sección  
            </a>
            -->
        </div>
    </div>

    <div id="list-block-dlg">
        <div class="content">
            <ul class='list-block'>
               <li class='handle'></li>
               <li><ul class="fields"></ul></li>
               <li class='template hidden'></li>
            </ul>
        </div>
        <textarea name="data">{JSON.stringify({
            "type": "ListBlock",
            "type_descr": "Tabla",
            "label": "Tabla",
            "visible": true,
            "titled": true,
            "max_items": "",
            "min_items": "",
            "erase":false,
            "insert":false,
            "copy_all":false,
            "copy_on_init": false,
            "discard_incompletes":false,
            "show_transposed": false,
            "show_aslist": true,
            "copy_row": false,
            "property":"",
            "view_roles": [],
            "edit_roles": [],
            "list_view": "",
            "list_view_footer": "",
            "insert_label": "Agregar una fila" 
        })}</textarea>
        <div class="dialog">
               <label>Título</label>
               <input type="text" size="28" name="label" value=""/>
                <p>Nombre con el cual se mostrará la tabla</p>
            <hr/>
                <label>Opciones</label>
                <p><input type="checkbox" name="visible"/>&nbsp;Visible</p>
                <p><input type="checkbox" name="titled"/>&nbsp;Con encabezado</p>
                <label>Máx filas</label>
                <input type="text" name="max_items" size="6"/>
                <p>Cantidad máxima de filas que puede alojar la tabla</p>
                <label>Min filas</label>
                <input type="text" name="min_items" size="6"/>
                <p>Cantidad m&iacute;nima de filas que puede alojar la tabla</p>

            <br/>
              <label>Permite</label>
              <p><input type="checkbox" name="erase"/> &nbsp; Borrar filas</p>
              <p><input type="checkbox" name="insert"/> &nbsp; Agregar filas</p>
              <p><input type="checkbox" name="copy_all"/> &nbsp; Copiar toda la tabla</p>
              <p><input type="checkbox" name="copy_on_init"/> &nbsp; Copiar al iniciar el formulario</p>
              <p><input type="checkbox" name="discard_incompletes"/> &nbsp; Descartar filas incompletas al guardar</p>
              <p><input type="checkbox" name="show_transposed"/> &nbsp; Mostrar Transpuesta</p>
              <p><input type="checkbox" name="show_aslist"/> &nbsp; Mostrar como lista</p>
              <p><input type="checkbox" name="copy_row" /> Copiar fila</p>

            <span name="list_view" class="group">
              <hr/>
              <h4>Plantillas para la lista (NUEVO !)</h4>
              <!-- -->
              <label  class="wide" >Para cada ítem</label>
              <textarea style="width:96%" rows="6" name="list_view"></textarea>
              <!-- -->
              <label class="wide">Al pie de la lista</label>
              <textarea style="width:96%" rows="6" name="list_view_footer"></textarea>
              <p class="wide">Explicar plantillas aqui </p>
              <!-- -->
              <span name="insert_label" class="group">
                <label class="wide" name="insert_label">Texto del botón para insertar filas</label>
                <input class="wide" type="text" name="insert_label" />
              </span>
            </span>
  
            <hr/>
              <h4>Que roles pueden ver o editar esta sección</h4>
              <label>Pueden<br>ver</label>
              <p name="view_roles" class="vars-list" data-only="fields">
                <span class="options"></span><select></select>
              </p>
              <p>Si no se ingresa ningún rol implica que todos los roles
                pueden ver esta sección
              </p>

              <label>Pueden<br>modificar</label>
                <p name="edit_roles" class="vars-list" data-only="fields">
                    <span class="options"></span><select></select>
                </p>
                <p>Si no se ingresa ningún rol implica que todos los roles
                    pueden editar esta sección.</p>
        </div>
    </div>

    <div id="paragraph-block-dlg">
        <div class="content"></div>
        <textarea name="data">{JSON.stringify({
            "type": "ParagraphBlock",
            "type_descr": "Párrafo",
            "hint": "",
            "description": "Texto aclaratorio dentro del formulario.",
            "visible": true,
            "property":"",
            "value":"",
            "label": "Parrafo",
            "view_roles": []
        })}</textarea>
        <div class="dialog">
            <label class="no-indent">Contenido</label>
            <textarea style="width:96%" rows="4" name="description"></textarea>
            <p class="wide">
                Texto acalaratorio para alguna parte del formulario.
                Si esta vacío no se muestra. Se respetan los altos de linea,
                y pueden usarse microformatos. Más info en
                    <a class="more" href="/faq.html?q=microformatos" target="_blank">Que son los microformatos ?</a>
            </p>
            <hr/>
                <label>Opciones</label>
                <p><input type="checkbox" name="visible"/> Visible al inicio</p>
                <p><input type="checkbox" name="hidden"/> Oculto siempre</p>
            <hr/>

            <h4>Que roles pueden ver esta sección</h4>
            <label>Pueden<br>ver</label>
                <p name="view_roles" class="vars-list" data-only="fields">
                    <span class="options"></span><select></select>
                </p>
                <p>Si no se ingresa ningún rol implica que todos los roles
                    pueden ver esta sección</p>
        </div>
    </div>

    <!--  FIELD INPUTS -->

    <div id="text-input">
        <div class="content"></div>
        <textarea name="data">{JSON.stringify({
            "type": "TextField",
            "type_descr": "Texto y variantes",
            "hint": "Ingresa el texto solicitado ...",
            "label": "Texto",
            "value": "",
            "required": false,
            "editable": true,
            "visible": true,
            "hidden": false,
            "width": "",
            "max": "",
            "property":"",
            "accept_copy": true,
            "subtype": "string"
        })}</textarea>
        <div class="dialog">
               <label>Tipo</label>
               <select name="subtype">
                    <option value="string">Texto corto</option>
                    <option value="title">Texto ancho</option>
                    <option value="notes">Área de notas</option>
               </select>
               <hr/>
               <label>Rótulo</label>
               <input type="text" size="20" name="label" value=""/>
               <p>Nombre que identifica al campo. No se muestra en el formulario</p>
               <hr/>
                   <label>Inicial</label><input size="28" type="text" name="value" />
                   <p>Valor inicial, puede contener microformatos.</p>
                   <label>Tamaño máximo (cars)</label>
                   <input size="5" type="text" name="max" placeholder="max"/>
                   <p>Tamaño máximo del texto (en caracteres). Puede estar vacío, en cuyo caso no se limita el tamaño.</p>
               <hr/>
                   <label>Opciones</label>
                   <p><input type="checkbox" name="required"/> Obligatorio</p>
                   <p><input type="checkbox" name="editable"/> Editable</p>
                   <p><input type="checkbox" name="visible"/> Visible al inicio</p>
                   <p><input type="checkbox" name="hidden"/> Oculto siempre</p>
                   <p><input type="checkbox" name="accept_copy"/> Acepta copia</p>
            <!--
                   <label name="sizer">Ancho</label>
                   <input name="sizer" type="range" style="width:17em"/>
                   -->
               <hr/>
               <label>Ayuda</label>
               <input size="28" type="text" name="hint" value=""/>
               <p>Texto indicativo que se usará al editar. Puede contener microformatos. Más info en
                    <a class="more-info" href="/faq.html?q=microformatos" target="_blank">Que son los microformatos ?</a></p>
               <hr/>
        </div>
    </div>

    <div id="number-input">
        <div class="content"></div>
        <textarea name="data">{JSON.stringify({
            "type": "NumberField",
            "type_descr": "Número y variantes",
            "subtype": "int",
            "hint": "Valor ...",
            "label": "Entero",
            "value": "",
            "min": "",
            "max": "",
            "extmin": "",
            "extmax": "",
            "required": false,
            "editable": true,
            "visible": true,
            "hidden": false,
            "width": "",
            "format": "",
            "accept_copy": true,
            "property":""
        })}</textarea>
        <div class="dialog">
             <label>Tipo</label>
               <select name="subtype">
                    <option value="int">Entero</option>
                    <option value="decimal">Decimal</option>
                    <option value="phone">Teléfono</option>
               </select>
            <hr/>
            <label>Rótulo</label><input size="20" type="text" name="label" value=""/>
            <p>El rótulo del campo, aparece a la izquierda</p>
            <hr/>
                <label>Inicial, mín y máx</label>
                <input size="5" type="text" name="value" />
                <input size="5" type="text" name="min" placeholder="min"/>
                <input size="5" type="text" name="max" placeholder="max"/>
                <p>Valor inicial, minimo y máximo. Pueden estar vacíos.</p>
                <label>Minlength y <br>maxlength</label>
  
                <input size="5" type="text" name="minlength" placeholder="min"/>
                <input size="5" type="text" name="maxlength" placeholder="max"/>
                <p>Longitud mínima y máxima de la palabra introducida.</p>
                
                <label>Limitado por ...</label>
                <select name="extmin" style="max-width:5em;"></select>
                &nbsp;y&nbsp;
                <select name="extmax" style="max-width:5em;"></select>
                <p>Indique si debe estar entre límites dados por otros
                campos de este formulario.</p>
                <label>Formato</label>
                <input size="12" type="text" name="format" value=""/>
                <p>Describa el formato para el número: los caracteres '#', '.' y ',' 
                    se usan para indicar formato. El resto de los caracteres
                    se interpetrarán literalmente. Por ejemplo: '$ ####,##' indica 
                    6 dígitos en total y dos dígitos decimales, prefijados
                    por los caracteres '$ '. El número '123.568' se mostrará como 
                    '$  123.57'</p>
                <hr/>
                   <label>Opciones</label>
                   <p><input type="checkbox" name="required"/> Obligatorio</p>
                   <p><input type="checkbox" name="editable"/> Editable</p>
                   <p><input type="checkbox" name="visible"/> Visible al inicio</p>
                   <p><input type="checkbox" name="hidden"/> Oculto siempre</p>
                   <p><input type="checkbox" name="accept_copy"/> Acepta copia</p>
            <hr/>
            <label>Ayuda</label>
               <input size="26" type="text" name="hint" value=""/>
               <p>Texto indicativo que se usará al editar. Puede contener microformatos. Más info en
                    <a class="more-info"  href="/faq.html?q=microformatos" target="_blank">Que son los microformatos ?</a></p>
            <hr/>
        </div>
    </div>

    <div id="date-input">
        <div class="content"></div>
        <textarea name="data">{JSON.stringify({
            "type": "DateField",
            "type_descr": "Fecha",
            "subtype": "date",
            "label": "Fecha",
            "min":"",
            "max":"",
            "value": "",
            "hint":"",
            "required": false,
            "editable": true,
            "visible": true,
            "hidden": false,
            "width": "",
            "auto": false,
            "accept_copy": true,
            "property":""
        })}</textarea>
        <div class="dialog">
             <label>Tipo</label>
               <select name="subtype">
                <option value="date">Calendario</option>
                <option value="datestr">Fecha (alfanum)</option>
                <!-- option value="datetime">Fecha y hora</option -->
                    <option value="visit">Fecha de visita (turnos disponibles)</option>
               </select>
            <hr/>
            <label>Rótulo</label>
            <input size="20" type="text" name="label" />
            <p>El rótulo del campo, aparece a la izquierda</p>
            <hr/>
            <label>Autoasignar</label>
                <input type="checkbox" name="auto" /> &nbsp; (automático)
                <p>Asigna en forma automática, leyendo del dispositivo</p>
            <hr/>
            <label>Inicial, mín y máx</label>
            <input size="5" type="text" name="value" />
            <input size="4" type="text" name="min" placeholder="min"/>
            <input size="4" type="text" name="max" placeholder="max"/>
            <p>Valor inicial, mínimo y máximo. Pueden estar vacíos.</p>
            <hr/>
                <label>Opciones</label>
                <p><input type="checkbox" name="required"/> Obligatorio</p>
                <p><input type="checkbox" name="editable"/> Editable</p>
                <p><input type="checkbox" name="visible"/> Visible al inicio</p>
                <p><input type="checkbox" name="hidden"/> Oculto siempre</p>
                <p><input type="checkbox" name="accept_copy"/> Acepta copia</p>
            <hr/>
            <label>Ayuda</label>
               <input size="28" type="text" name="hint" value=""/>
               <p>Texto indicativo que se usará al editar. Puede contener microformatos. Más info en
                    <a class="more-info"  href="/faq.html?q=microformatos" target="_blank">Que son los microformatos ?</a></p>
               <hr/>
        </div>
    </div>

    <div id="time-input">
        <div class="content"></div>
        <textarea name="data">{JSON.stringify({
            "type": "TimeField",
            "type_descr": "Hora y variantes",
            "subtype": "time",
            "label": "Hora",
            "min":"",
            "max":"",
            "value": "",
            "hint":"",
            "required": false,
            "editable": true,
            "visible": true,
            "hidden": false,
            "width": "",
            "auto": false,
            "accept_copy": true,
            "property":""
        })}</textarea>
        <div class="dialog">
             <label>Tipo</label>
               <select name="subtype">
                    <option value="time">Hora reducida (hh:mm)</option>
                    <option value="timestamp">Hora completa (hh:mm:ss)</option>
               </select>
            <hr/>
            <label>Rótulo</label>
            <input size="20" type="text" name="label" />
            <p>El rótulo del campo, aparece a la izquierda</p>
            <hr/>
            <label>Autoasignar</label>
                <input type="checkbox" name="auto" /> &nbsp; (automático)
                <p>Asigna en forma automática, leyendo del dispositivo</p>
            <hr/>
            <label>Inicial, mín y máx</label>
            <input size="5" type="text" name="value" />
            <input size="4" type="text" name="min" placeholder="min"/>
            <input size="4" type="text" name="max" placeholder="max"/>
            <p>Valor inicial, mínimo y máximo. Pueden estar vacíos.</p>
            <hr/>
                   <label>Opciones</label>
                   <p><input type="checkbox" name="required"/> Obligatorio</p>
                   <p><input type="checkbox" name="editable"/> Editable</p>
                   <p><input type="checkbox" name="visible"/> Visible al inicio</p>
                   <p><input type="checkbox" name="hidden"/> Oculto siempre</p>
                   <p><input type="checkbox" name="accept_copy"/> Acepta copia</p>
            <hr/>
            <label>Ayuda</label>
               <input size="28" type="text" name="hint" value=""/>
               <p>Texto indicativo que se usará al editar. Puede contener microformatos. Más info en
                    <a class="more-info" href="/faq.html?q=microformatos" target="_blank">Que son los microformatos ?</a></p>
               <hr/>
        </div>
    </div>

    <div id="check-input">
        <div class="content"></div>
        <textarea name="data">{JSON.stringify({
            "type": "CheckField",
            "subtype": "default",
            "type_descr": "Tildar (si/no)",
            "label": "Tildar",
            "value":"",
            "state": true,
            "editable": true,
            "visible": true,
            "hidden": false,
            "width": "",
            "hint": "",
            "accept_copy": true,
            "property":""
        })}</textarea>
        <div class="dialog">
             <label>Tipo</label>
               <select name="subtype">
                    <option value="default">Normal</option>
                    <option value="warning">Aviso</option>
                    <option value="alarm">Alarma</option>
               </select>
            <hr/>
            <label>Rótulo</label>
            <input size="20" type="text" name="label" value=""/>
            <p>El rótulo del campo, aparece a la izquierda</p>
            <hr/>
            <label>Valor</label>
            <input type="text" name="value" size="28" />
            <p>El valor que se asignará a este campo cuando se encuentre tildado.</p>
            <hr/>
                <label>Inicial</label>
                &nbsp; <input type="checkbox" name="state"/> (tildado / no tildado)
                <p>El estado inicial para el tilde</p>
            <hr/>
                <label>Opciones</label>
                <p><input type="checkbox" name="editable"/> Editable</p>
                <p><input type="checkbox" name="visible"/> Visible al inicio</p>
                <p><input type="checkbox" name="hidden"/> Oculto siempre</p>
                <p><input type="checkbox" name="accept_copy"/> Acepta copia</p>
            <hr/>
                <label>Ayuda</label>
                <input size="28" type="text" name="hint" value=""/>
                <p>Texto indicativo que se usará al editar. Puede contener microformatos. Más info en
                    <a class="more-info" href="/faq.html?q=microformatos" target="_blank">Que son los microformatos ?</a></p>
        </div>
    </div>

    <div id="option-input">
        <div class="content"></div>
        <textarea name="data">{JSON.stringify({
            "type": "OptionField",
            "subtype": "options",
            "type_descr": "Opciones y variantes",
            "hint": "Seleccione una de las opciones",
            "label": "Opciones",
            "value": "",
            "options":[],
            "values":[],
            "required":false,
            "editable": true,
            "visible": true,
            "hidden": false,
            "width": "",
            "accept_copy": true,
            "property":""
        })}</textarea>
        <div class="dialog">
                <label>Tipo</label>
                <select name="subtype">
                    <option value="options">Todas visibles</option>
                    <option value="select">Como lista</option>
                    <option value="lights rounded">Semáforo (redondo)</option>
                    <option value="lights square">Semáforo (cuadrado)</option>
                    <option value="lights toggle">Señalizador</option>
                    <option value="emoticons">Emoticones</option>
                </select>
                <p class="wide">Las opciones standard muestran una lista que permite seleccionar la opcion deseada, tan solo tocando la misma.</p>
                <p class="wide">Los semáforos muestran tres luces (cuadradas o redondas). Deben ingresarse para cada opción los codigos :ROJO, :VERDE y :AMARILLO y sus respectivas descripciones.</p>
                <p class="wide">El señalizador es similar a los semáforos pero muestra una sola luz que permite alternar entre las distintas opciones,tocando repetidas veces.</p>
            <hr/>
                <label>Rótulo</label>
                <input size="20" type="text" name="label" value=""/>
                <p>El rótulo del campo, aparece a la izquierda</p>
            <hr/>
                <label class="no-indent">Opciones</label>
                <p class="options wide"></p>
                <p class="wide">
                    <button class="add rounded float-right AddOptionBtn"></button>
                    Agregue las opciones que se incluirán en la lista de selección.
                    Tenga en cuenta que no se deben repetir valores en la lista.
                    </p>
            <hr/>
                   <label>Opciones</label>
                   <p><input type="checkbox" name="required"/> Obligatorio</p>
                   <p><input type="checkbox" name="editable"/> Editable</p>
                   <p><input type="checkbox" name="visible"/> Visible al inicio</p>
                   <p><input type="checkbox" name="hidden"/> Oculto siempre</p>
                   <p><input type="checkbox" name="accept_copy"/> Acepta copia</p>
            <hr/>
               <label>Ayuda</label>
               <input size="28" type="text" name="hint" value=""/>
               <p>Texto indicativo que se usará al editar. Puede contener microformatos. Más info en
                    <a class="more-info" href="/faq.html?q=microformatos" target="_blank">Que son los microformatos ?</a></p>
            <hr/>
        </div>
    </div>

    <!-- ***** WIP ***** -->

    <div id="base64-field">
        <div class="content"></div>
        <textarea name="data">{JSON.stringify({
            "type": "Base64Field",
            "type_descr": "Base64",
            "label": "Base64",
            "hint": "El presente se llenará con un enlace para descargar un archivo PDF",
            "value":"",
            "required": false,
            "editable": true,
            "visible": true,
            "hidden": false,
            "width": "",
            "multiple": true,
            "accept_copy": true,
            "property":"",
            "subtype": "pdf"
        })}</textarea>
        <div class="dialog">
                <label>Rótulo</label>
                <input size="20" type="text" name="label" value=""/>
                <p>El rótulo del campo, aparece a la izquierda</p>
            <hr />
                <label>Tipo</label>
                <select name="subtype">
                    <option value="pdf">PDF</option>
                    <option value="img">Imagen</option>
                </select>
            <hr/>
                <label>Opciones</label>
                    <p><input type="checkbox" name="required"/> Obligatorio</p>
                    <!-- <p><input type="checkbox" name="editable"/> Editable</p> -->
                    <p><input type="checkbox" name="visible"/> Visible al inicio</p>
                    <p><input type="checkbox" name="hidden"/> Oculto siempre</p>
                    <!-- <p><input type="checkbox" name="accept_copy"/> Acepta copia</p> -->
            <hr/>
                <label>Ayuda</label>
                <input size="28" type="text" name="hint" value=""/>
                <p>Texto indicativo que se usará al editar. Puede contener microformatos. Más info en
                <a class="more" href="/faq.html?q=microformatos" target="_blank">Que son los microformatos ?</a></p>
            <hr/>
        </div>
    </div>

        <!-- ***** WIP ***** -->
    <!-- LIST SELECTOR FIELDS -->

    <div id="code-selector">
        <div class="content"></div>
        <textarea name="data">{JSON.stringify({
            "type": "CodeSelectorField",
            "type_descr": "Seleccionar código de una lista",
            "hint": "Seleccione un código de la lista",
            "label": "Codigo",
            "associated_list": "",
            "value": "",
            "required": false,
            "editable": true,
            "filter":"",
            "property":""
        })}</textarea>
        <div class="dialog">
                <label>Rótulo</label>
                <input size="20" type="text" name="label" value=""/>
                <p>El rótulo del campo, aparece a la izquierda</p>
            <hr/>
                <label>Lista a utilizar</label>
                <select name="associated_list"></select>
                <p>Seleccione la lista que se usará para mostrar los códigos.
                Debe ser una de las listas cargadas en el sistema,
                y debe estar vigente.</p>
                <label>Filtrada por</label>
                <select name="filter"></select>
                <p>Indique si los items a mostrar dependen de algún otro
                campo de este formulario.</p>
            <hr/>
                <label>Inicial</label>
                <input size="28" type="text" name="value" />
                <p>Valor inicial que se asignará antes de elegir algún ítem de la lista</p>
            <hr/>
                   <label>Opciones</label>
                   <p><input type="checkbox" name="required"/> Obligatorio</p>
                   <p><input type="checkbox" name="editable"/> Editable</p>
            <hr/>
               <label>Ayuda</label>
               <input size="28" type="text" name="hint" value=""/>
               <p>Texto indicativo que se usará al editar. Puede contener microformatos. Más info en
                    <a class="more-info" href="/faq.html?q=microformatos" target="_blank">Que son los microformatos ?</a></p>
            <hr/>
        </div>
    </div>

    <div id="object-selector">
        <div class="content"></div>
        <textarea name="data">{JSON.stringify({
            "type": "ObjectSelectorField",
            "type_descr": "Ítem de una lista",
            "hint": "Seleccione un ítem de la lista",
            "label": "Item",
            "associated_list":"",
            "value": "",
            "required":false,
            "editable": true,
            "visible": true,
            "hidden": false,
            "append": false,
            "width": "",
            "property":"",
            "filter":"",
            "accept_copy": true,
            "fields": []
        })}</textarea>
        <div class="dialog">
                <label>Rótulo</label>
                <input size="20" type="text" name="label" value=""/>
                <p>El rótulo del campo, aparece a la izquierda</p>
            <hr/>
                <label>Lista a utilizar</label>
                <select name="associated_list"></select>
                <p>Seleccione la lista que se usará para mostrar los ítems.
                Debe ser una de las listas cargadas en el sistema,
                y debe estar vigente.</p>
                <label>Filtrada por</label>
                <select name="filter"></select>
                <p>Indique si los items a mostrar dependen de algún otro
                campo de este formulario.</p>
            <hr/>
                <label>Inicial</label>
                <input size="28" type="text" name="value" />
                <p>Valor inicial que se asignará antes de elegir algún ítem de la lista</p>
            <hr/>
                <label>Opciones</label>
                <p><input type="checkbox" name="required"/> Obligatorio</p>
                <p><input type="checkbox" name="editable"/> Editable</p>
                <p><input type="checkbox" name="visible"/> Visible al inicio</p>
                <p><input type="checkbox" name="hidden"/> Oculto siempre</p>
                <p><input type="checkbox" name="append"/> Pueden agregarse items</p>
                <p><input type="checkbox" name="accept_copy"/> Acepta copia</p>

            <hr/>
               <label>Ayuda</label>
               <input size="28" type="text" name="hint" value=""/>
               <p>Texto indicativo que se usará al editar. Puede contener microformatos. Más info en
                    <a class="more-info" href="/faq.html?q=microformatos" target="_blank">Que son los microformatos ?</a></p>
            <hr/>
        </div>
    </div>

    <!-- CAPTURE BUTTONS  -->

    <div id="gps-capture">
        <div class="content"></div>
        <textarea name="data">{JSON.stringify({
            "type": "GpsField",
            "type_descr": "Lectura GPS",
            "label": "Ubicación",
            "hint": "Capture su ubicación actual",
            "value": "",
            "required": false,
            "editable": true,
            "visible": true,
            "hidden": false,
            "width": "",
            "accept_copy": true,
            "property":""
        })}</textarea>
        <div class="dialog">
                <label>Rótulo</label>
                <input size="20" type="text" name="label" value=""/>
                <p>El rótulo del campo, aparece a la izquierda</p>
            <hr/>
                <label>Opciones</label>
                <p><input type="checkbox" name="required"/> Obligatorio</p>
                <p><input type="checkbox" name="editable"/> Editable</p>
                <p><input type="checkbox" name="visible"/> Visible al inicio</p>
                <p><input type="checkbox" name="hidden"/> Oculto siempre</p>
                <p><input type="checkbox" name="accept_copy"/> Acepta copia</p>
            <hr/>
               <label>Ayuda</label>
               <input size="30" type="text" name="hint" value=""/>
               <p>Texto indicativo que se usará al editar. Puede contener microformatos. Más info en
                  <a class="more" href="/faq.html?q=microformatos" target="_blank">Que son los microformatos ?</a>
                </p>
            <hr/>
        </div>
    </div>

    <div id="photo-capture">
        <div class="content"></div>
        <textarea name="data">{JSON.stringify({
            "type": "PhotoField",
            "type_descr": "Fotos",
            "label": "Foto",
            "hint": "Presione el botón para tomar la foto",
            "value":"",
            "required": false,
            "editable": true,
            "visible": true,
            "hidden": false,
            "width": "",
            "multiple": true,
            "accept_copy": true,
            "property":""
        })}</textarea>
        <div class="dialog">
                <label>Rótulo</label>
                <input size="20" type="text" name="label" value=""/>
                <p>El rótulo del campo, aparece a la izquierda</p>
            <hr/>
                <label>Opciones</label>
                   <p><input type="checkbox" name="multiple"/> Más de una foto</p>
                   <p><input type="checkbox" name="required"/> Obligatorio</p>
                   <p><input type="checkbox" name="editable"/> Editable</p>
                   <p><input type="checkbox" name="visible"/> Visible al inicio</p>
                   <p><input type="checkbox" name="hidden"/> Oculto siempre</p>
                   <p><input type="checkbox" name="accept_copy"/> Acepta copia</p>
            <hr/>
               <label>Ayuda</label>
               <input size="28" type="text" name="hint" value=""/>
               <p>Texto indicativo que se usará al editar. Puede contener microformatos. Más info en
                <a class="more" href="/faq.html?q=microformatos" target="_blank">Que son los microformatos ?</a></p>
            <hr/>
        </div>
    </div>

    <div id="attachs-capture">
        <div class="content"></div>
        <textarea name="data">{JSON.stringify({
            "type": "AttachsField",
            "type_descr": "Adjuntos",
            "label": "Adjunto",
            "hint": "Elija los archivos a adjuntar",
            "value":"",
            "exts": "*",
            "required": false,
            "editable": true,
            "visible": true,
            "hidden": false,
            "width": "12",
            "multiple": true,
            "accept_copy": true,
            "property":""
        })}</textarea>
        <div class="dialog">
                <label>Rótulo</label>
                <input size="20" type="text" name="label" value=""/>
                <p>El rótulo del campo, aparece a la izquierda</p>
            <hr/>
                <label>Tipos</label>
                <input size="20" type="text" name="types" value="*"/>
                <p>Indique los tipos de archivo que permitirá adjuntar.
                Ingresar la lista de extensiones permitidas separada por comas, o bien <i>*</i> para indicar que puede adjuntar cualquier tipo de archivo. Por ej: <i>jpg,png,giff,doc,pdf,*</i></p>
            <hr/>
                   <label>Opciones</label>
                   <p><input type="checkbox" name="multiple"/> Múltiples (más de uno)</p>
                   <p><input type="checkbox" name="required"/> Obligatorio</p>
                   <p><input type="checkbox" name="editable"/> Editable</p>
                   <p><input type="checkbox" name="visible"/> Visible al inicio</p>
                   <p><input type="checkbox" name="hidden"/> Oculto siempre</p>
                   <p><input type="checkbox" name="accept_copy"/> Acepta copia</p>
            <hr/>
               <label>Ayuda</label>
               <input size="28" type="text" name="hint" value=""/>
               <p>Texto indicativo que se usará al editar. Puede contener microformatos. Más info en
                    <a class="more" href="/faq.html?q=microformatos" target="_blank">Que son los microformatos ?</a></p>
            <hr/>
        </div>
    </div>

    <div id="barcode-capture">
        <div class="content"></div>
        <textarea name="data">{JSON.stringify({
            "type": "BarcodeField",
            "type_descr": "Código de barras",
            "label": "Código Barras",
            "hint": "Presione el botón para escanear el código",
            "required": false,
            "editable": true,
            "visible": true,
            "hidden": false,
            "width": "",
            "accept_copy": true,
            "property":""
        })}</textarea>
        <div class="dialog">
                <label>Rótulo</label>
                <input size="20" type="text" name="label" value=""/>
                <p>El rótulo del campo, aparece a la izquierda</p>
            <hr/>
                   <label>Opciones</label>
                   <p><input type="checkbox" name="required"/> Obligatorio</p>
                   <p><input type="checkbox" name="editable"/> Editable</p>
                   <p><input type="checkbox" name="visible"/> Visible al inicio</p>
                   <p><input type="checkbox" name="hidden"/> Oculto siempre</p>
                   <p><input type="checkbox" name="accept_copy"/> Acepta copia</p>
            <hr/>
               <label>Ayuda</label>
               <input size="28" type="text" name="hint" value=""/>
               <p>Texto indicativo que se usará al editar. Puede contener microformatos. Más info en
                <a class="more" href="/faq.html?q=microformatos" target="_blank">Que son los microformatos ?</a></p>
            <hr/>
        </div>
    </div>

    <div id="qrcode-capture">
        <div class="content"></div>
        <textarea name="data">{JSON.stringify({
            "type": "QRcodeField",
            "type_descr": "Código QR",
            "label": "QR/Barras",
            "hint": "Presione el botón para escanear el código",
            "required": false,
            "editable": true,
            "visible": true,
            "hidden": false,
            "width": "",
            "value":"",
            "accept_copy": true,
            "property":""
        })}</textarea>
        <div class="dialog">
                <label>Rótulo</label>
                <input size="20" type="text" name="label" value=""/>
                <p>El rótulo del campo, aparece a la izquierda</p>
            <hr/>
                   <label>Opciones</label>
                   <p><input type="checkbox" name="required"/> Obligatorio</p>
                   <p><input type="checkbox" name="editable"/> Editable</p>
                   <p><input type="checkbox" name="visible"/> Visible al inicio</p>
                   <p><input type="checkbox" name="hidden"/> Oculto siempre</p>
                   <p><input type="checkbox" name="accept_copy"/> Acepta copia</p>
            <hr/>
               <label>Ayuda</label>
               <input size="28" type="text" name="hint" value=""/>
               <p>Texto indicativo que se usará al editar. Puede contener microformatos. Más info en
                    <a class="more-info"  href="/faq.html?q=microformatos" target="_blank">Que son los microformatos ?</a></p>
            <hr/>
        </div>
    </div>

    <div id="graph-view">
        <div class="content"></div>
        <textarea name="data">{JSON.stringify({
            "type": "GraphField",
            "type_descr": "Gráfico",
            "label": "Gráfico",
            "hint": "",
            "graph": "",
            "max": "",
            "min": "",
            "ref": "",
            "required": false,
            "editable": true,
            "visible": true,
            "hidden": false,
            "width": "",
            "value":"",
            "accept_copy": true,
            "property":""
        })}</textarea>
        <div class="dialog">
            <label>Rótulo</label>
            <input size="20" type="text" name="label" value=""/>
            <p>Un nombre para este cálculo</p>
            <hr/>
                <label>Tipo</label>
                <select name="graph">
                    <option value="line-graph">Lineas</option>
                </select>
                <p>Seleccione el tipo del gráfico.</p>
            <hr/>
                <label>Inicial, mín y máx</label>
                <input size="6" type="text" name="ref" />
                <input size="4" type="text" name="min" placeholder="min"/>
                <input size="4" type="text" name="max" placeholder="max"/>
                <p>Valores referencia, mínimo y máximo. Pueden estar vacíos.</p>
            <hr/>
               <label>Opciones</label>
               <p><input type="checkbox" name="editable"/> Editable</p>
               <p><input type="checkbox" name="visible"/> Visible al inicio</p>
               <p><input type="checkbox" name="hidden"/> Oculto siempre</p>
               <p><input type="checkbox" name="accept_copy"/> Acepta copia</p>
            <hr/>
               <label>Ayuda</label>
               <input size="28" type="text" name="hint" value=""/>
               <p>Texto indicativo que se usará al editar. Puede contener microformatos. Más info en
                    <a class="more-info"  href="/faq.html?q=microformatos" target="_blank">Que son los microformatos ?</a></p>
            <hr/>
        </div>
    </div>


    <div id="signature-capture">
      <div class="content"></div>
      <textarea name="data">{JSON.stringify({
          "type": "SignatureField",
          "type_descr": "Firma",
          "label": "Firma",
          "hint": "Presione el botón para tomar la firma",
          "value":"",
          "required": false,
          "editable": true,
          "visible": true,
          "hidden": false,
          "width": "",
          "multiple": true,
          "accept_copy": true,
          "property":""
      })}</textarea>
      <div class="dialog">
        <label>Rótulo</label>
        <input size="20" type="text" name="label" value=""/>
        <p>El rótulo del campo, aparece a la izquierda</p>
        <hr/>
          <label>Opciones</label>
          <p><input type="checkbox" name="required"/> Obligatorio</p>
          <p><input type="checkbox" name="editable"/> Editable</p>
          <p><input type="checkbox" name="visible"/> Visible al inicio</p>
          <p><input type="checkbox" name="hidden"/> Oculto siempre</p>
          <p><input type="checkbox" name="accept_copy"/> Acepta copia</p>
        <hr/>
          <label>Ayuda</label>
          <textarea cols="26" rows="2" name="hint" value=""/>
          <p>Texto indicativo que se usará al editar. Puede contener microformatos. Más info en
          <a class="more" href="/faq.html?q=microformatos" target="_blank">Que son los microformatos ?</a></p>
          <hr/>
      </div>
    </div>


    <!-- LOGICAL & OPERATIONS FIELDS -->

    <div id="calculation-logic" class="form-component-editor">
        <div class="content"></div>
        <textarea name="data">{JSON.stringify({
            "type": "CalculatedField",
            "plugin": "CalculatedField",
            "type_descr": "Cálculos",
            "label": "Calculo",
            "hint": "Valor ...",
            "value": "",
            "max": "",
            "min": "",
            "extmin": "",
            "extmax": "",
            "required": false,
            "editable": true,
            "visible": true,
            "hidden": false,
            "width": "",
            "function": "",
            "expression": [],
            "inputs": [],
            "code": "",
            "initial": "",
            "consumes": "",
            "adds": "",
            "property":"",
            "accept_copy": false,
            "format": ""
        })}</textarea>
        <div class="dialog">
                <label>Tipo</label>
                <select name="function">
                    <option value="formula">Fórmula</option>
                    <option value="totalizar">Totalizador</option>
                    <option value="disponible">Disponible</option>
                </select>
                <p>Seleccione la funcion que se utilizará en el cálculo.</p>
            <hr/>
                <label>Rótulo</label>
                <input size="20" type="text" name="label" value=""/>
                <p>Un nombre para este cálculo</p>
            <hr/>
                <label>Inicial, mín y máx</label>
                <input size="5" type="text" name="value" />
                <input size="4" type="text" name="min" placeholder="min"/>
                <input size="4" type="text" name="max" placeholder="max"/>
                <p>Valores inicial, mínimo y máximo. Pueden estar vacíos.</p>
                <label>Limitado por ...</label>
                <select name="extmin" style="max-width:5em;"></select>
                &nbsp;y&nbsp;
                <select name="extmax" style="max-width:5em;"></select>
                <p>Indique si debe estar entre límites dados por otros
                campos de este formulario.</p>
            <hr/>
                <label>Formato</label>
                <input size="12" type="text" name="format" value=""/>
                <p>Describa el formato para el número: los caracteres '#', '.' y ',' 
                se usan para indicar formato. El resto de los caracteres
                se interpetrarán literalmente. Por ejemplo: '$ ####,##' indica 
                6 dígitos en total y dos dígitos decimales, prefijados
                por los caracteres '$ '. El número '123.568' se mostrará como 
                '$  123.57'</p>
            <hr/>
            <div class='form-component-div formula-totalizar'>
                <label>Expresión</label>
                <p class="no-margin">&nbsp;</p>
                <p class="no-margin totalizar">Elija la columna a totalizar.</p>
                <p class="no-margin formula">Arme aquí la fórmula o expresión a usar en el cálculo.</p>
                <p name="expression" class="vars-list no-margin">
                    <span class="options"></span>
                    <br/>
                    <label>Puede agregar</label>
                    <select name="vars"></select>
                    <br/><br/>
                    <span class="formula">
                        <label>También </label>
                        <select name="ops">
                            <option value="">Operadores ...</option>
                            <option value="+">+</option>
                            <option value="-">-</option>
                            <option value="*">*</option>
                            <option value="/">/</option>
                            <option value="(">(</option>
                            <option value=")">)</option>
                            <option value="&&">y</option>
                            <option value="||">o</option>
                            <option value="<">menor que</option>
                            <option value=">">mayor que</option>
                            <option value="==">igual a</option>
                            <option value="!=">distinto de</option>
                            <option value="!">no es</option>
                            <option value="?">entonces</option>
                            <option value=":">otro</option>
                        </select>
                        <br/><br/>
                        <label>Funciones </label>
                        <select name="fns">
                            <option value="">Funciones ...</option>
                            <option value="age_today" args="1">edad hoy</option>
                        </select>
                        <br/><br/>
                        <label>Y números </label>
                        <input type="text" size="8" name="ctte" class="flush" style="border-radius:0px"/>
                        <button name="btn-ctte" style="font-size:1em;font-weight:bold;">&#8629;</button>
                    </span>
                    </p>
                    <p class="no-margin formula">Puede <b>ordenar</b> los elementos de la fórmula arrastrando y soltando.
                    <br/>Para <b>borrar</b> un elemento haga click sobre el mismo y destilde.</p>
                </div>
            <div class='form-component-div disponible'>
                  <label>Código</label>
                  <select name="code"></select>
                  <br/>
                  <p class="hint">Campo que contiene el código del producto que debemos verificar si ya existe o no en alguna fila anterior a esta.</p>
                  <label>Inicial</label>
                  <select name="initial"></select>
                  <br/>
                  <p class="hint">Campo que contiene el valor 'Inicial' del stock que existe en la lista para un cierto producto al momento de abrir el formulario. Este valor se debería copiar al elegir el producto.</p>
                  <label>Consumo</label>
                  <select name="consumes"></select>
                  <br/>
                  <p class="hint">Campo que contiene el valor que se consume del stock. Puede quedar vacío si no hay ningún campo asociado.</p>
                  <label>Aporte</label>
                  <select name="adds"></select>
                  <br/>
                  <p class="hint">Campo que contiene el valor que se adiciona al stock. Puede quedar vacío si no hay ningún campo asociado.</p>
                </div>
                <hr/>
                <label>Opciones</label>
                <p><input type="checkbox" name="required"/> Obligatorio</p>
                <p><input type="checkbox" name="visible"/> Visible al inicio</p>
                <p><input type="checkbox" name="hidden"/> Oculto siempre</p>
            <hr/>
        </div>
    </div>

    <div id="concatenation-logic" class="form-component-editor">
      <div class="content"></div>
      <textarea name="data">{JSON.stringify({
          "type": "ConcatenatedField",
          "plugin": "ConcatenatedField",
          "type_descr": "Concatenación de varios campos",
          "label": "Concatenar",
          "hint": "",
          "value": "",
          "max": "",
          "min": "",
          "extmin": "",
          "extmax": "",
          "required": false,
          "editable": true,
          "visible": true,
          "hidden": false,
          "width": "",
          "function": "",
          "expression": [],
          "inputs": [],
          "code": "",
          "initial": "",
          "consumes": "",
          "adds": "",
          "property":"",
          "accept_copy": false,
          "format": ""
      })}</textarea>
      <div class="dialog">
              <label>Tipo</label>
              <select name="function">
                  <option value="formula">Expresión</option>
                  <!-- <option value="totalizar">Totalizador</option>
                  <option value="disponible">Disponible</option> -->
              </select>
              <!-- <p>Seleccione la funcion que se utilizará en la concatenación.</p> -->
          <hr/>
              <label>Rótulo</label>
              <input size="20" type="text" name="label" value=""/>
              <p>Un nombre para esta operación</p>
          <hr/>
              <label>Inicial</label>
              <input size="20" type="text" name="value" />
              <!-- <input size="4" type="text" name="min" placeholder="min"/>
              <input size="4" type="text" name="max" placeholder="max"/> -->
              <p>Valor inicial. Puede estar vacío.</p>
              <!-- <label>Limitado por ...</label>
              <select name="extmin" style="max-width:5em;"></select>
              &nbsp;y&nbsp;
              <select name="extmax" style="max-width:5em;"></select>
              <p>Indique si debe estar entre límites dados por otros
              campos de este formulario.</p> -->
          <!-- <hr/>
              <label>Formato</label>
              <input size="12" type="text" name="format" value=""/>
              <p>Describa el formato para el número: los caracteres '#', '.' y ',' 
              se usan para indicar formato. El resto de los caracteres
              se interpetrarán literalmente. Por ejemplo: '$ ####,##' indica 
              6 dígitos en total y dos dígitos decimales, prefijados
              por los caracteres '$ '. El número '123.568' se mostrará como 
              '$  123.57'</p> -->
          <hr/>
          <div class='form-component-div formula-totalizar'>
              <label>Expresión</label>
              <p class="no-margin">&nbsp;</p>
              <p class="no-margin totalizar">Elija la columna a totalizar.</p>
              <p class="no-margin formula">Arme aquí la expresión a usar para concatenar los campos.</p>
              <p name="expression" class="vars-list no-margin">
                  <span class="options"></span>
                  <br/>
                  <label>Puede agregar</label>
                  <select name="vars"></select>
                  <br/><br/>
                  <span class="formula">
                      <!-- <label>También </label>
                      <select name="ops">
                          <option value="">Operadores ...</option>
                          <option value="+">+</option>
                          <option value="-">-</option>
                          <option value="*">*</option>
                          <option value="/">/</option>
                          <option value="(">(</option>
                          <option value=")">)</option>
                          <option value="&&">y</option>
                          <option value="||">o</option>
                          <option value="<">menor que</option>
                          <option value=">">mayor que</option>
                          <option value="==">igual a</option>
                          <option value="!=">distinto de</option>
                          <option value="!">no es</option>
                          <option value="?">entonces</option>
                          <option value=":">otro</option>
                      </select> -->
                      <!-- <label>Funciones </label>
                      <select name="fns">
                          <option value="">Funciones ...</option>
                          <option value="age_today" args="1">edad hoy</option>
                      </select>
                      <br/><br/> -->
                      <label>y texto fijo </label>
                      <input type="text" size="14" name="ctte" class="flush" style="border-radius:0px"/>
                      <button class="btn-add-constant" name="btn-ctte" style="font-size:1em;font-weight:bold;">&#8629;</button>
                  </span>
                  </p>
                  <p class="no-margin formula">Puede <b>ordenar</b> los elementos de la fórmula arrastrando y soltando.
                  <br/>Para <b>borrar</b> un elemento haga click sobre el mismo y destilde.</p>
              </div>
          <div class='form-component-div disponible'>
                <label>Código</label>
                <select name="code"></select>
                <br/>
                <p class="hint">Campo que contiene el código del producto que debemos verificar si ya existe o no en alguna fila anterior a esta.</p>
                <label>Inicial</label>
                <select name="initial"></select>
                <br/>
                <p class="hint">Campo que contiene el valor 'Inicial' del stock que existe en la lista para un cierto producto al momento de abrir el formulario. Este valor se debería copiar al elegir el producto.</p>
                <label>Consumo</label>
                <select name="consumes"></select>
                <br/>
                <p class="hint">Campo que contiene el valor que se consume del stock. Puede quedar vacío si no hay ningún campo asociado.</p>
                <label>Aporte</label>
                <select name="adds"></select>
                <br/>
                <p class="hint">Campo que contiene el valor que se adiciona al stock. Puede quedar vacío si no hay ningún campo asociado.</p>
              </div>
              <hr/>
              <label>Opciones</label>
              <p><input type="checkbox" name="required"/> Obligatorio</p>
              <p><input type="checkbox" name="visible"/> Visible al inicio</p>
              <p><input type="checkbox" name="hidden"/> Oculto siempre</p>
          <hr/>
      </div>
    </div>

    <div id="conditional-logic">
        <div class="content"></div>
        <textarea name="data">{JSON.stringify({
            "type": "ConditionalFields",
            "plugin": "ConditionalFields",
            "type_descr": "Mostrar/ocultar campos",
            "label": "Mostrar",
            "hint": "Muestra u oculta campos según la condición lógica ingresada",
            "property":"",
            "visible": false,
            "hidden": true,
            "recursive": false,
            "inputs": [],
            "outputs": [],
            "expression": ""
        })}</textarea>
        <div class="dialog">
            <hr/>
                <label>Rótulo</label>
                <input size="20" type="text" name="label" value=""/>
                <p>Un nombre para este condicional</p>
            <hr/>
                <label>Aplicar a ...</label>
                <p name="outputs" class="vars-list"><span class="options"></span><select></select></p>
                <p>Campos que se haran visibles si se cumple la condición,
                o se ocultaran si no la cumple.</p>
            <hr/>
                <label>Expresión lógica</label>
                <p class="no-margin">&nbsp;</p>
                <p class="no-margin">Arme aquí la expresión lógica que se usará para habilitar o
                deshabilitar los campos indicados.</p>
                <p name="expression" class="vars-list no-margin">
                   <span class="options"
                         style="font-weight:bold;font-size:1.2em;background-color:#bbb;padding:6px;display:block;"></span>
                   <br/>
                   <label>Puede agregar</label>
                   <select name="vars"></select>
                   <br/><br/>
                   <label>También </label>
                   <select name="ops">
                        <option value="">Operadores ...</option>
                            <option value="(">(</option>
                            <option value=")">)</option>
                            <option value="&&">y</option>
                            <option value="||">o</option>
                            <option value="<">menor que</option>
                            <option value=">">mayor que</option>
                            <option value="==">igual a</option>
                            <option value="!=">distinto de</option>
                            <option value="!">no es</option>
                            <option value="== 1">esta tildado</option>
                            <option value="== 0">esta destildado</option>
                            <option value="=== EMPTY">esta vacío</option>
                            <option value="!== EMPTY">no esta vacío</option>
                   </select>
                   <br/><br/>
                   <label>Y números </label>
                   <input type="text" size="14" name="ctte" class="flush" style="border-radius:0px"/>
                   <button name="btn-ctte" style="font-size:1em;font-weight:bold;">&#8629;</button>
                </p>
                <p class="no-margin">Puede <b>ordenar</b> los elementos de la expresión arrastrando y soltando.
                <br/>Para <b>borrar</b> un elemento haga click sobre el mismo y destilde.</p>
            <hr/>
        </div>
    </div>

    <div id="conditional-logic-sections">
        <div class="content"></div>
        <textarea name="data">{JSON.stringify({
            "type": "ConditionalSectionsOnly",
            "plugin": "ConditionalSectionsOnly",
            "type_descr": "Mostrar/ocultar secciones",
            "label": "Mostrar sección",
            "hint": "Muestra u oculta secciones según la condición lógica ingresada",
            "property":"",
            "visible": false,
            "hidden": true,
            "recursive": false,
            "inputs": [],
            "outputs": [],
            "expression": ""
        })}</textarea>
        <div class="dialog">
            <hr/>
                <label>Rótulo</label>
                <input size="20" type="text" name="label" value=""/>
                <p>Un nombre para este condicional</p>
            <hr/>
                <label>Aplicar a ...</label>
                <p name="outputs" class="vars-list" data-only="sections"><span class="options"></span><select></select></p>
                <p>Secciones que se haran visibles si se cumple la condición,
                o se ocultaran si no la cumple.</p>
            <hr/>
                <label>Expresión lógica</label>
                <p class="no-margin">&nbsp;</p>
                <p class="no-margin">Arme aquí la expresión lógica que se usará para habilitar o
                deshabilitar las secciones indicadas.</p>
                <p name="expression" class="vars-list no-margin">
                   <span class="options"
                         style="font-weight:bold;font-size:1.2em;background-color:#bbb;padding:6px;display:block;"></span>
                   <br/>
                   <label>Puede agregar</label>
                   <select name="vars"></select>
                   <br/><br/>
                   <label>También </label>
                   <select name="ops">
                        <option value="">Operadores ...</option>
                            <option value="(">(</option>
                            <option value=")">)</option>
                            <option value="&&">y</option>
                            <option value="||">o</option>
                            <option value="<">menor que</option>
                            <option value=">">mayor que</option>
                            <option value="==">igual a</option>
                            <option value="!=">distinto de</option>
                            <option value="!">no es</option>
                            <option value="== 1">esta tildado</option>
                            <option value="== 0">esta destildado</option>
                            <option value="=== EMPTY">esta vacío</option>
                            <option value="!== EMPTY">no esta vacío</option>
                   </select>
                   <br/><br/>
                   <label>Y números </label>
                   <input type="text" size="14" name="ctte" class="flush" style="border-radius:0px"/>
                   <button name="btn-ctte" style="font-size:1em;font-weight:bold;">&#8629;</button>
                </p>
                <p class="no-margin">Puede <b>ordenar</b> los elementos de la expresión arrastrando y soltando.
                <br/>Para <b>borrar</b> un elemento haga click sobre el mismo y destilde.</p>
            <hr/>
        </div>
    </div>

    <div id="conditional-logic-fields">
        <div class="content"></div>
        <textarea name="data">{JSON.stringify({
            "type": "ConditionalFieldsOnly",
            "plugin": "ConditionalFieldsOnly",
            "type_descr": "Mostrar/ocultar campos",
            "label": "Mostrar campos",
            "hint": "Muestra u oculta campos según la condición lógica ingresada",
            "property":"",
            "visible": false,
            "hidden": true,
            "recursive": false,
            "inputs": [],
            "outputs": [],
            "expression": ""
        })}</textarea>
        <div class="dialog">
            <hr/>
                <label>Rótulo</label>
                <input size="20" type="text" name="label" value=""/>
                <p>Un nombre para este condicional</p>
            <hr/>
                <label>Aplicar a ...</label>
                <p name="outputs" class="vars-list" data-only="fields"><span class="options"></span><select></select></p>
                <p>Campos que se haran visibles si se cumple la condición,
                o se ocultaran si no la cumple.</p>
            <hr/>
                <label>Expresión lógica</label>
                <p class="no-margin">&nbsp;</p>
                <p class="no-margin">Arme aquí la expresión lógica que se usará para habilitar o
                deshabilitar los campos indicados.</p>
                <p name="expression" class="vars-list no-margin">
                   <span class="options"
                         style="font-weight:bold;font-size:1.2em;background-color:#bbb;padding:6px;display:block;"></span>
                   <br/>
                   <label>Puede agregar</label>
                   <select name="vars"></select>
                   <br/><br/>
                   <label>También </label>
                   <select name="ops">
                        <option value="">Operadores ...</option>
                            <option value="(">(</option>
                            <option value=")">)</option>
                            <option value="&&">y</option>
                            <option value="||">o</option>
                            <option value="<">menor que</option>
                            <option value=">">mayor que</option>
                            <option value="==">igual a</option>
                            <option value="!=">distinto de</option>
                            <option value="!">no es</option>
                            <option value="== 1">esta tildado</option>
                            <option value="== 0">esta destildado</option>
                            <option value="=== EMPTY">esta vacío</option>
                            <option value="!== EMPTY">no esta vacío</option>
                   </select>
                   <br/><br/>
                   <label>Y números </label>
                   <input type="text" size="14" name="ctte" class="flush" style="border-radius:0px"/>
                   <button name="btn-ctte" style="font-size:1em;font-weight:bold;">&#8629;</button>
                </p>
                <p class="no-margin">Puede <b>ordenar</b> los elementos de la expresión arrastrando y soltando.
                <br/>Para <b>borrar</b> un elemento haga click sobre el mismo y destilde.</p>
            <hr/>
        </div>
    </div>

    <div id="conditional-logic-rows">
        <div class="content"></div>
        <textarea name="data">{JSON.stringify({
            "type": "ConditionalRowsOnly",
            "plugin": "ConditionalRowsOnly",
            "type_descr": "Filtrar filas",
            "label": "Filtrar filas",
            "hint": "Muestra u oculta filas según la condición lógica ingresada",
            "property":"",
            "visible": false,
            "hidden": true,
            "recursive": false,
            "inputs": [],
            "outputs": [],
            "expression": ""
        })}</textarea>
        <div class="dialog">
            <hr/>
                <label>Rótulo</label>
                <input size="20" type="text" name="label" value=""/>
                <p>Un nombre para este condicional</p>
            <hr/>
                <label>Aplicar a ...</label>
                <p name="outputs" class="vars-list" data-only="rows"><span class="options"></span><select></select></p>
                <p>Filas que se haran visibles si se cumple la condición,
                o se ocultaran si no la cumple.</p>
            <hr/>
                <label>Filtradas por</label>
                <p class="no-margin">&nbsp;</p>
                <p class="no-margin">Agregue los campos cuyos valores se usarán para filtrar las filas.</p>
                <p name="expression" class="vars-list no-margin">
                   <span class="options"
                         style="font-weight:bold;font-size:1.2em;background-color:#bbb;padding:6px;display:block;"></span>
                   <br/>
                   <label>Campos</label>
                   <select name="vars"></select>
                   <span class="hidden">
                    <br/><br/>
                    <label>También </label>
                    <select name="ops">
                        <option value="">Operadores ...</option>
                            <option value="&&">y</option>
                            <option value="==">filtrado por</option>
                    </select>
                    <br/>
                   </span>
                </p>
                <p class="no-margin">Puede <b>ordenar</b> los elementos de la expresión arrastrando y soltando.
                <br/>Para <b>borrar</b> un elemento haga click sobre el mismo y destilde.</p>
            <hr/>
        </div>
    </div>

    <div id="more-options">
        <div class="content"></div>
        <textarea name="data">{JSON.stringify({
            "type": "MoreOptions",
            "plugin": "MoreOptions",
            "type_descr": "Activar opciones adicionales",
            "label": "Activar opciones",
            "hint": "Activa/desactiva ciertas opciones particulares de este formulario.",
            "property": "",
            "drafts": true,
            "print": false,
            "download": false,
            "copy": true
        })}</textarea>
        <div class="dialog">
            <label>Rótulo</label>
            <input size="20" type="text" name="label" value=""/>
            <p class="wide">Opciones particulares de este formulario</p>
            <hr/>
            <label class="wide">Botones de acción (standard)</label>
            <p><input type="checkbox" name="drafts"/> Guardar Borrador ...</p>
            <p><input type="checkbox" name="print"/> Imprimir ...</p>
            <p><input type="checkbox" name="download"/> Bajar ...</p>
            <p><input type="checkbox" name="copy"/> Copiar ...</p>
            <hr/>
            <p class="wide">En el futuro aquí se podrán agregar al formulario 
                otras opciones ...</p>
            <hr/>
        </div>
    </div>
    
    <div id="list-columns-copy">
        <div class="content"></div>
        <textarea name="data">{JSON.stringify({
            "type": "ListColumnsCopy",
            "plugin": "ListColumnsCopy",
            "type_descr": "Copiar columnas",
            "label": "Copiar",
            "item": "",
            "associated_list": "",
            "copies": [],
            "hidden": true,
            "property":""
        })}</textarea>
        <!--
        NOTA: "copies" es un array de objetos del tipo { col:, var: }
              donde 'col' es la columna a copiar,
              y 'var' es el campo del form destinatario de la copia.
        NOTA: "field" DEBE ser un campo de tipo item
        -->
        <div class="dialog">
                <label>Rótulo</label>
                <input size="20" type="text" name="label" value=""/>
                <p>Un nombre para esta operación</p>
            <hr/>
                <label>Campo <br/>activado</label>
                <select name="item"></select>
                <p>Seleccione el campo que disparará la copia de los valores
                de la lista. Cuando este campo cambie, se copiaran los valores de las
                columnas indicadas a los campos indicados.</p>
            <hr/>
                <label>Lista <br/>a copiar</label>
                <select name="associated_list"></select>
                <p>Seleccione la lista que se usará como fuente de datos para la copia.
                Debe ser una de las listas cargadas en el sistema,
                y debe estar vigente.</p>
            <hr/>
                <label class="no-indent">Copiar ...</label>
                <p class="container wide"></p>
                <p class="wide">
                    <button class="add rounded float-left AddOptionBtn"></button>
                    Agregue las columnas y campos que se copiaran desde la lista.
                    Tenga en cuenta que no se deben repetir valores.
                    <br/>
                </p>
            <hr/>
        </div>
    </div>

    <div id="list-column-logic">
        <div class="content"></div>
        <textarea name="data">{JSON.stringify({
            "type": "ListColumnField",
            "type_descr": "Mostrar una valor de la lista",
            "label": "Columna",
            "associated_list": "",
            "column": "",
            "output": [],
            "hidden": true,
            "property":""
        })}</textarea>
        <div class="dialog">
                <label>Nombre</label>
                <input size="20" type="text" name="label" value=""/>
                <p>Un nombre para este cálculo</p>
            <hr/>
                <label>Lista <br/>a mostrar</label>
                <select name="associated_list"></select>
                <p>Seleccione la lista que se usará para mostrar los ítems.
                Debe ser una de las listas cargadas en el sistema,
                y debe estar vigente.</p>
            <hr/>
                <label class="no-indent"></label>
                <p class="options wide"></p>
                <p class="wide">
                    <button class="add rounded float-right AddOptionBtn"></button>
                    Agregue las opciones que se incluirán en la lista de selección.
                    Tenga en cuenta que no se deben repetir valores en la lista.
                    </p>

            <hr/>
                <label>Campo</label>
                <p name="output" class="vars-list"><span class="options"></span><select></select></p>
                <p>Campo donde se mostrará la columna elegida.</p>
            <hr/>
        </div>
    </div>


    <!-- PLUGINS -->

    <div id="local-stock-plugin">
        <div class="content"></div>
        <textarea name="data">{JSON.stringify({
            "type": "LocalStockPlugin",
            "type_descr": "Calcular stocks",
            "name": "LocalStock",
            "label": "Stock en tablet",
            "table": "",
            "col_initial": "",
            "col_sold": "",
            "col_stock": "",
            "list": "",
            "selector": "",
            "initial0": "",
            "initial1": "",
            "initial2": "",
            "quantity": "",
            "final": "",
            "hidden": true,
            "property":""
        })}</textarea>
        <div class="dialog">
                <label>Nombre</label>
                <input size="20" type="text" name="label" value=""/>
                <p>Un nombre para este componente</p>
            <hr/>
                <label>Tabla<br/>con stocks</label>
                <select name="table"></select>
                <p>Seleccione la lista sobre la cual se operará.
                 Debe ser una de las listas cargadas en el sistema,
                 y debe estar vigente.</p>
                <label>Col. Inicial</label>
                <input size="20" type="text" name="col_initial" value=""/>
                <br/>
                <label>Col. Vendido</label>
                <input size="20" type="text" name="col_sold" value=""/>
                <br/>
                <label>Col. Stock</label>
                <input size="20" type="text" name="col_stock" value=""/>
                <p>Ingrese el Nro. (comenzando desde cero)
                de cada una de la columnas que
                se modificarán como resultado de las operaciónes.</p>
            <hr/>
                <label>Lista</label>
                <input size="20" type="text" name="list" value=""/>
                <br/>
                <label>Item</label>
                <input size="20" type="text" name="selector" value=""/>
                <br/>
                <label>Asignado</label>
                <input size="20" type="text" name="initial0" value=""/>
                <br/>
                <label>Inicial1</label>
                <input size="20" type="text" name="initial1" value=""/>
                <br/>
                <label>Inicial2</label>
                <input size="20" type="text" name="initial2" value=""/>
                <br/>
                <label>Pedido</label>
                <input size="20" type="text" name="quantity" value=""/>
                <br/>
                <label>Final</label>
                <input size="20" type="text" name="final" value=""/>
                <p>Ingrese la propiedad de cada uno de los campos
                   que se usaran y donde se copiarán los resultados del cálculo.</p>
            <hr/>
        </div>
    </div>

    <div id="local-ticket-plugin">
        <div class="content"></div>
        <textarea name="data">{JSON.stringify({
            "type": "LocalTicketPlugin",
            "plugin": "LocalTicketPlugin",
            "type_descr": "Emitir PDF",
            "label": "Ticket",
            "hint": "Una vez emitido ya no puede modificarse el formulario !",
            "subject": "",
            "return_mail": "",
            "body": "",
            "counter": "",
            "template": "",
            "inputs": [],
            "emails": [],
            "required": true,
            "editable": true,
            "visible": true,
            "hidden": false,
            "blockit": true,
            "launchit": true,
            "property":""
        })}</textarea>
        <div class="dialog">
            <label>Título</label>
                <input size="20" type="text" name="label" value=""/>
                <p class="no-margin">El titulo para el recibo a emitir. Por ej. Recibo de Cobranzas.</p>
            <label class="no-indent">Plantilla</label>
                <textarea rows="8" name="template" id="ticket-template-txtarea"
                   style="font-size:7pt;line-height:12pt;width:97%;font-family:monospace;">
                </textarea>
                <button name="generaPlantillaBtn" id="generaPlantillaBtn" class="generaPlantillaBtn">Generar Plantilla</button>
            <hr/>
            <label>Contador</label>
                <input size="20" type="text" name="counter" value=""/>
                <p  class="no-margin">Que contador (de los contadores de cada usuario) se usará para numerar los recibos.
                    Si ingresa el ID de un campo del formulario, se usara el mismo para nombrar el PDF.
                    Ej: "X-#texto_4"</p>
            <hr/>
            <label>Opciones</label>
                <p><input type="checkbox" name="required"/> Obligatorio</p>
                <p><input type="checkbox" name="visible"/> Visible al inicio</p>
                <p><input type="checkbox" name="hidden"/> Oculto siempre</p>
                <p><input type="checkbox" name="blockit"/> Bloquear al emitir</p>
                <p><input type="checkbox" name="launchit"/> Abrir luego de emitir</p>
                <div class="hidden">
                    <label>Solo emitir si ...</label>
                    <p name="inputs" class="vars-list" data-only="fields">
                        <span class="options"></span><select></select>
                    </p>
                    <p>Que campo del formulario indica si se permite emitir el recibo.</p>
                </div>
            <hr/>   
            <label>Correos a</label>
                <p name="emails" class="vars-list" data-only="fields">
                    <span class="options"></span><select></select>
                </p>
                <p>Campos que se usan para definir a que correos enviar los recibos.</p>
            <label>Asunto</label>
                <input size="30" type="text" name="subject" value=""/>
                <p>El asunto del mensaje a enviar". (si no se especifica se usara un asunto generico)</p>
            <label>Cuerpo</label>
                <textarea rows="3" cols="30" name="body" style="line-height:1.2em;"></textarea>
                <p>Cuerpo del correo.</p>
            <label>Enviar desde</label>
                <input size="30" type="text" name="return_mail" value=""/>
                <p>Casillas de correo del remitente del ticket. (si no se especifica se usará
                    el mail del usuario administrador)</p>
            <hr/>
            <label>Ayuda</label>
                <input size="28" type="text" name="hint" value=""/>
                <p class="no-margin">Texto indicativo que se usará al editar. Puede contener microformatos. Más info en <a class="more-info" href="/faq.html?q=microformatos" target="_blank">
                    Que son los microformatos ?</a></p>
            <hr/>
        </div>
    </div>

    <div id="local-updatelist-plugin">
        <div class="content"></div>
        <textarea name="data">{JSON.stringify({
            "type": "LocalUpdatelistPlugin",
            "type_descr": "Actualiza lista local",
            "label": "Actualizar Lista",
            "associated_list": "",
            "copies": [],
            "hidden": true,
            "visible": false,
            "property": ""
        })}</textarea>
        <div class="dialog">
                <label>Rótulo</label>
                <input size="20" type="text" name="label" value=""/>
                <p>Un nombre para la operación</p>
            <hr/>
            <div class="form-component-div">
              <label>Lista<br/>a modificar</label>
              <select name="associated_list"></select>
              <p>Seleccione la lista que se actualizara.
                Debe ser una de las listas cargadas en el sistema,
                y debe estar vigente.</p>
                <hr/>
                <label class="no-indent">Copiar ...</label>
                <p class="container wide"></p>
                <p class="wide">El primer campo se usará para identificar 
                    la fila a actualizar, y por ello debe contener 
                    el código de la fila en la lista.</p>  
                <p class="wide">
                  <button class="add rounded float-left AddOptionBtn"></button>
                  Agregue los campos que se usarán para actualizar las 
                  columnas de la lista. 
                  <br/>
                </p>
            </div>
            <hr/>
        </div>
    </div>
    
    <div id="email-alert-plugin">
        <div class="content"></div>
        <textarea name="data">{JSON.stringify({
            "type": "EmailAlertPlugin",
            "plugin": "EmailAlertPlugin",
            "type_descr": "Enviar alertas",
            "label": "Alerta",
            "hint": "Envia una alerta por correo cuando se cumple cierta condición lógica.",
            "subject": "",
            "emails": "",
            "level": "",
            "body": "",
            "inputs": [],
            "outputs": [],
            "expression": "",
            "required": false,
            "editable": false,
            "visible": false,
            "hidden": false,
            "property":""
        })}</textarea>
        <div class="dialog">
                <label>Rótulo</label>
                    <input size="30" type="text" name="label" value=""/>
                    <p>Nombre para identificarla. Por ej. "Insuficiente".</p>
                <label>Asunto</label>
                    <input size="30" type="text" name="subject" value=""/>
                    <p>El mensaje de alerta a enviar. Por ej. "Puntaje por debajo del mínimo !".</p>
                <label>Enviar a</label>
                    <textarea rows="2" cols="30" name="emails" style="line-height:1.2em;"></textarea>
                    <p>Casillas de correo a las cuales enviar esta alerta. Separadas por ";"</p>
                <label>Cuerpo</label>
                    <textarea rows="3" cols="30" name="body" style="line-height:1.2em;"></textarea>
                    <p>Cuerpo del correo. Puede contener microformatos y campos del formulario.</p>
                <label>Prioridad</label>
                    <select name="level">
                        <option value="Urgente">Urgente !</option>
                        <option value="Alta">Alta</option>
                        <option value="Normal">Normal</option>
                        <option value="Baja">Baja</option>
                    </select>
            <hr/>
                <label>Cuando emitir ?</label>
                <p class="no-margin">&nbsp;</p>
                <p class="no-margin">Arme aquí la expresión lógica que se usará para evaluar
                si se debe emitir la alerta.</p>
                <p name="expression" class="vars-list no-margin">
                   <span class="options"
                         style="font-weight:bold;font-size:1.2em;background-color:#bbb;padding:6px;display:block;"></span>
                   <br/>
                   <label>Puede agregar</label>
                   <select name="vars"></select>
                   <br/><br/>
                   <label>También </label>
                   <select name="ops">
                        <option value="">Operadores ...</option>
                            <option value="(">(</option>
                            <option value=")">)</option>
                            <option value="&&">y</option>
                            <option value="||">o</option>
                            <option value="<">menor que</option>
                            <option value=">">mayor que</option>
                            <option value="==">igual a</option>
                            <option value="!=">distinto de</option>
                            <option value="!">no es</option>
                            <option value="== 1">esta tildado</option>
                            <option value="== 0">esta destildado</option>
                            <option value="=== EMPTY">esta vacío</option>
                            <option value="!== EMPTY">no esta vacío</option>
                   </select>
                   <br/><br/>
                   <label>Y números </label>
                   <input type="text" size="14" name="ctte" class="flush" style="border-radius:0px"/>
                   <button name="btn-ctte" style="font-size:1em;font-weight:bold;">&#8629;</button>
                </p>
                <p class="no-margin">Puede <b>ordenar</b> los elementos de la expresión arrastrando y soltando.
                <br/>Para <b>borrar</b> un elemento haga click sobre el mismo y destilde.</p>
            <hr/>
                <label>Opciones</label>
                <p><input type="checkbox" name="visible"/> Visible al inicio</p>
                <p><input type="checkbox" name="hidden"/> Oculto siempre</p>
            <hr/>
        </div>
    </div>

    <div id="remote-call-plugin">
        <div class="content"></div>
        <textarea name="data">{JSON.stringify({
            "type": "RemoteCallPlugin",
            "plugin": "RemoteCallPlugin",
            "type_descr": "Solicitud remota",
            "label": "Servicio",
            "hint": "Click en este campo para obtener el CTG !",
            "service": "",
            "params": "",
            "results": "",
            "required": false,
            "hidden": false,
            "visible": true,
            "autolock": true,
            "property":""})}</textarea>
        <div class="dialog">
                <label>Rótulo</label>
                <input size="20" type="text" name="label" value=""/>
                <p>Un nombre para esta solicitud</p>
            <hr/>
                <label class="wide">Servicio a solicitar</label>
                <select class="wide" name="service">
                  <option value="ECHO">ECO: de parámetros para probar llamados remotos.</option>
                  <option value="AUTOSEQ">SECUENCIA: Auto numeración secuencial y única.</option>
                  <option value="WSAFIP-autorizarCPEAutomotor">AFIP: Autorizar Carta de Porte Electrónica.</option>
                  <option value="WSAFIP-anularCPE">AFIP: Anular Carta de Porte Electrónica.</option>
                  <!-- DEPRECATED <option value="AFIP-WSCTG">AFIP-CTG: Código de Trazabilidad de Granos</option> -->
                  <!-- DEPRECATED: <option value="WSAFIP-CPEAutomotor">AFIP: Autorizar Carta de Porte Electrónica.</option> -->
                </select>
                <p class="wide">Seleccione el servicio a solicitar.</p>
            <hr/>
                <label>Parámetros</label>
                <p name="params" class="vars-list wide" data-only="fields">
                    <span class="options"></span><select></select>
                </p>
                <p class="wide">Seleccione los campos que se utilizarán como parametros del servicio remoto.</p>
            <hr/>
                <label>Resultados</label>
                <p name="results" class="vars-list wide" data-only="fields">
                    <span class="options"></span><select></select>
                </p>
                <p class="wide">Seleccione los campos donde se copiaran los valores obtenidos como resultado de
                    la solicituda remota.</p>
            <hr/>
                <label>Opciones</label>
                <p><input type="checkbox" name="required"/> Obligatorio</p>
                <p><input type="checkbox" name="visible"/> Visible al inicio</p>
                <p><input type="checkbox" name="hidden"/> Oculto siempre</p>
                <p><input type="checkbox" name="autolock"/> Bloquear al asignar</p>
            <hr/>
            <label>Ayuda</label>
            <p class="wide">
              <textarea rows="2" name="hint" style="width:100%;line-height:1.2em;"></textarea>
              <br/>
              Texto indicativo que se usará al editar. Puede contener microformatos. Más info en
              <a class="more-info" href="/faq.html?q=microformatos" target="_blank">Que son los microformatos ?</a></p>
            <hr/>
        </div>
    </div>

    <div id="pdf-fusion-plugin">
        <div class="content"></div>
        <textarea name="data">{JSON.stringify({
            "type": "PdfFusionPlugin",
            "plugin": "PdfFusionPlugin",
            "type_descr": "Fusionar PDF",
            "label": "PDFusion",
            "overlay": "",
            "backg": "",
            "result": "",
            "hidden": false,
            "visible": true,
            "property":""
        })}</textarea>
        <div class="dialog">
                <label>Rótulo</label>
                <input size="20" type="text" name="label" value=""/>
                <p>Un nombre para este campo.</p>
            <hr/>
                <label>Frente</label>
                <select name="overlay"></select>
                <p>Seleccione el campo que contiene el PDF a usar como frente.</p>
            <hr/>
                <label>Fondo</label>
                <select name="backg"></select>
                <p>Seleccione el campo que contiene el PDF a usar como fondo.</p>
            <hr/>
                <label>Resultado</label>
                <select name="result"></select>
                <p>Seleccione el campo que guardará el PDF resultante.
                    <b>IMPORTANTE</b>: puede ser uno de los archivos de entrada.</p>
            <hr/>
                <label>Opciones</label>
                <p><input type="checkbox" name="visible"/> Visible al inicio</p>
                <p><input type="checkbox" name="hidden"/> Oculto siempre</p>
        </div>
    </div>

    <!-- NO ESTAN EN USO -->

    <div id="ro-item">
        <div class="content">
            <h4></h4>
        </div>
        <textarea name="data">{JSON.stringify({
            "type": "RoitemCtrl",
            "type_descr": "Leyenda: Item de lista",
            "title":"Un item no editable",
            "bubble": "",
            "description": "Algo aca",
            "property":""
        })}</textarea>
        <div class="dialog">
            <label>Título del item</label>
            <input size="40" type="text" name="title" value=""/>
            <p></p>
            <label>Burbuja (lateral derecha)</label><input size="20" type="text" name="bubble" />
            <p>Si esta vacio no se muestra, puede contener variables ((var))</p>
            <label>Descripción</label><textarea cols="40" rows="4" name="description"></textarea>
            <p>Si esta vacío no se muestra, puede contener variables ((var)).
                <br/>Se respetan saltos de linea, y pueden usarse microformatos.
            </p>
        </div>
    </div>

    <div id="ro-header">
        <div class="content">
            <h3></h3>
        </div>
        <textarea name="data">{JSON.stringify({
            "type": "RoheaderCtrl",
            "type_descr": "Leyenda: Encabezado de lista",
            "title": "Un encabezado no editable",
            "bubble": ""
        })}</textarea>
        <div class="dialog">
            <label>Texto del encabezado</label>
            <input size="40" type="text" name="title" value=""/>
            <p>Se muestra aunque este vacio, puede contener variables ((var))</p>
            <label>Burbuja (lateral derecha)</label><input size="20" type="text" name="bubble" />
            <p>Si esta vacio no se muestra, puede contener variables ((var))</p>
        </div>
    </div>

<!-- field-dialog-templates -->
